import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Input/Input.Icon.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var TEXT_INPUT_CLASSNAME_MAP = {};
var InputIcon = _a => {
  var _b = _a,
    {
      children,
      className
    } = _b,
    rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */jsx("span", __spreadProps(__spreadValues({
    className: clsx("pd:input__icon", className)
  }, rest), {
    children
  }));
};
var Input_Icon_default = InputIcon;
export { TEXT_INPUT_CLASSNAME_MAP, Input_Icon_default };